module.exports = __webpack_public_path__ + "img/size.2091dde4.svg";